module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/a24ddcf4d5d0fbc351f7d2df4654ecd1.jpg";